<!-- ProblemSection.vue -->
<section id="ProblemSection" class="problem-section position-relative overflow-hidden py-5">
    <div class="container py-4">
        <div class="row align-items-center g-5">

        <!-- LEFT -->
        <div class="col-12 col-lg-6">
            <div class="d-flex align-items-center gap-3 text-uppercase text-xs fw-semibold problem-kicker">
            <span class="kicker-line"></span>
            <span>{{ problem_data.kicker }}</span>
            </div>

            <h2 class="problem-title mt-3 mb-3">
            {{ problem_data.title }}
            </h2>

            <p class="problem-lead mb-0">
            {{ problem_data.description }}
            </p>
        </div>

        <!-- RIGHT -->
        <div class="col-12 col-lg-6">
            <div class="d-flex flex-column gap-4">

            <!-- BIG STAT -->
            <div>
                <div class="problem-stat-value">
                {{ problem_data.stat_value }}
                </div>
                <div class="problem-stat-label">
                {{ problem_data.stat_label }}
                </div>
            </div>

            <!-- CARDS -->
            <div class="row g-4">
                <div class="col-12">
                <div class="problem-card problem-card-red rounded-4 p-4">
                    <div class="text-uppercase text-xs fw-semibold problem-card-kicker problem-card-kicker-red mb-2">
                    {{ problem_data.cards[0].kicker }}
                    </div>
                    <p class="mb-3 problem-card-text">
                    {{ problem_data.cards[0].text }}
                    </p>
                    <div class="problem-card-flow text-xs">
                    {{ problem_data.cards[0].flow }}
                    </div>
                </div>
                </div>

                <div class="col-12">
                <div class="problem-card problem-card-green rounded-4 p-4">
                    <div class="text-uppercase text-xs fw-semibold problem-card-kicker problem-card-kicker-green mb-2">
                    {{ problem_data.cards[1].kicker }}
                    </div>
                    <p class="mb-3 problem-card-text">
                    {{ problem_data.cards[1].text }}
                    </p>
                    <div class="problem-card-flow text-xs">
                    {{ problem_data.cards[1].flow }}
                    </div>
                </div>
                </div>
            </div>
            <!-- /CARDS -->

            </div>
        </div>

        </div>
    </div>
</section>
